import { render } from "./checkboxField.vue?vue&type=template&id=c661a258&ts=true"
import script from "./checkboxField.vue?vue&type=script&lang=ts"
export * from "./checkboxField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__